import React, { useState } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { postCampaignData, putCampaignData } from "api/CampaignApi";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import {
  setCampaignId,
  setCampaignName,
  setCampaignDescription,
  setCampaignType,
  setCampaignSubject,
  setCampaignAudienceName,
  setCampaignAudienceId,
  setcampaignEditMode,
  setCampignTemplateId,
} from "ReduxStore/Slices/campaignSlice";
import ContantLoader from "../../ContantLoader";
import "./style.scss";


export default function CampaignScheduleModal() {
  const history = useHistory();
  const campaignData = useSelector((state) => state.campaignSetter);
  const [campaignScheduleType, setCampaignScheduleType] = useState("now");
  const [campaignScheduleRecurranceType, setCampaignScheduleRecurranceType] =
    useState("");
  const [weekManageDate, setWeekManageDate] = useState("");
  const [monthManageDate, setMonthManageDate] = useState("");
  const [manageDate, setManageDate] = useState("");
  const [time, setTime] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const dispatch = useDispatch();

  const scheduleTypeHandler = (e) => {
    e.preventDefault();
    setCampaignScheduleType(e.target.value);
    if (e.target.value === "now") {
      document.getElementById("1blockdate").value = "";
      document.getElementById("1blocktime").value = "";
      document.getElementById("schedule-div").style.display = "none";
      document.getElementById("1Block").style.display = "none";
      document.getElementById("2Block").style.display = "none";
      document.getElementById("3Block").style.display = "none";
      document.getElementById("1blockdate").required = false;
      document.getElementById("1blocktime").required = false;
      document.getElementById("Run_Now").disabled = false;
      document.getElementById("finalize").disabled = true;
    }
    //ANCHOR Type Once
    else if (e.target.value === "once") {
      document.getElementById("schedule-div").style.display = "none";
      document.getElementById("2Block").style.display = "none";
      document.getElementById("3Block").style.display = "none";
      document.getElementById("1Block").style.display = "";
      document.getElementById("firstRun-div").style.display = "";
      document.getElementById("1blockdate").value = "";
      document.getElementById("1blocktime").value = "";
      document.getElementById("1blockdate").required = true;
      document.getElementById("1blocktime").required = true;
      document.getElementById("Repeat-every-div").style.display = "none";
      document.getElementById("End-on-div").style.display = "none";
      document.getElementById("repeat-on-div").style.display = "none";
      document.getElementById("Run_Now").disabled = true;
      document.getElementById("finalize").disabled = false;
    }
    //ANCHOR Type Recurring
    else if (e.target.value === "recurring") {
      document.getElementById("1blockdate").value = "";
      document.getElementById("1blocktime").value = "";
      document.getElementById("1blockdate").required = false;
      document.getElementById("1blocktime").required = false;
      document.getElementById("defaultSelected").style.display = "";
      document.getElementById("getschedule").selectedIndex = 0;
      document.getElementById("2Block").style.display = "none";
      document.getElementById("3Block").style.display = "none";
      document.getElementById("firstRun-div").style.display = "none";
      document.getElementById("Repeat-every-div").style.display = "none";
      document.getElementById("End-on-div").style.display = "none";
      document.getElementById("repeat-on-div").style.display = "none";
      document.getElementById("schedule-div").style.display = "";
      document.getElementById("1Block").style.display = "none"; //
      document.getElementById("firstRun-div").style.display = "none";
      document.getElementById("Run_Now").disabled = true;
      document.getElementById("finalize").disabled = false;
    }
  };

  const scheduleRecurranceTypeHandler = (e) => {
    e.preventDefault();
    document.getElementById("defaultSelected").style.display = "none";
    setCampaignScheduleRecurranceType(e.target.value);
    if (e.target.value === "daily") {
      document.getElementById("2Block").style.display = "";
      document.getElementById("1Block").style.display = "none";
      document.getElementById("3Block").style.display = "none";
      document.getElementById("2BlockDate").required = true;
      document.getElementById("2BlockTime").required = true;
      document.getElementById("2BlockrepeatEvery").required = true;
    }
    //ANCHOR Type Monthly
    else if (e.target.value === "monthly") {
      document.getElementById("1blockdate").value = "";
      document.getElementById("1blockdate").value = "";
      document.getElementById("2Block").style.display = "none";
      document.getElementById("1Block").style.display = ""; //
      document.getElementById("firstRun-div").style.display = "";
      document.getElementById("3Block").style.display = "none";
      document.getElementById("Repeat-every-div").style.display = "";
      document.getElementById("repeat-on-div").style.display = "";
      document.getElementById("End-on-div").style.display = "";
      document.getElementById("1blockdate").required = true;
      document.getElementById("1blocktime").required = true;
      document.getElementById("1blockrepeatEvery").required = true;
    }
    //ANCHOR Type Weekly
    else if (e.target.value === "weekly") {
      document.getElementById("2Block").style.display = "none";
      document.getElementById("1Block").style.display = "none";
      document.getElementById("3Block").style.display = "";
      document.getElementById("3Blockdate").required = true;
      document.getElementById("3Blocktime").required = true;
      document.getElementById("3BlockrepeatEvery").required = true;
    }
  };

  // ANCHOR Date Handler
  const datePickupHandler = (e) => {
    e.preventDefault();
    if (e.target.id === "3Blockdate") {

      setWeekManageDate(e.target.value);
      console.log("3rd",e.target.value)
      try {
        document.getElementById('3BlockTime').value = "";
      } catch (e) {
        console.log(e)

      }
    } else if (e.target.id === "1blockdate") {
      document.getElementById("1blockdatePicker").value = "";
      setMonthManageDate(e.target.value);
      console.log("1st",e.target.value)
      try {
        console.log(document.getElementById('1blocktime'))
        document.getElementById('1blocktime').value = "";
      } catch (e) {
        console.log(e)

      }
    } else {
      document.getElementById("2Blockdate").value = "";
      setManageDate(e.target.value);
      console.log("2nd",e.target.value)
      try {
        document.getElementById('2BlockTime').value = "";
      } catch (e) {
        console.log(e)

      }
    }

  };

  function formatTime(ts) {
    var H = +ts.substr(0, 2);
    var h = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " am" : " pm";
    ts = h + ts.substr(2, 3) + ampm;
    return ts
  }

  // ANCHOR Time Handler
  const timePickupHandler = (e) => {
    

    console.log("vvvvvvvv", e.target.value, moment().add(5, 'minutes').format("HH:mm"))

    if (e.target.id === "1blocktime") {
      if (moment().format("YYYY-MM-DD") == moment(monthManageDate).format("YYYY-MM-DD") && moment().add(5, 'minutes').format("HH:mm") > e.target.value) {
        e.target.value = moment().add(5, 'minutes').format("HH:mm")
        toast.info("Please select a date time at least 5 minutes from now.");
      }
      setTime(formatTime(e.target.value));
      // this.setState({ time: ts });
      // 
      console.log("1nd", e.target.value)

    } else if (e.target.id === "2BlockTime") {
      if (moment().format("YYYY-MM-DD") == moment(manageDate).format("YYYY-MM-DD") && moment().add(5, 'minutes').format("HH:mm") > e.target.value) {
        e.target.value = moment().add(5, 'minutes').format("HH:mm")
        toast.info("Please select a date time at least 5 minutes from now.");
      }
      setTime(formatTime(e.target.value));
      // this.setState({ time: ts });
      // 
      console.log("2nd", e.target.value)

    } else {
      if (moment().format("YYYY-MM-DD") == moment(weekManageDate).format("YYYY-MM-DD") && moment().add(5, 'minutes').format("HH:mm") > e.target.value) {
        e.target.value = moment().add(5, 'minutes').format("HH:mm")
        toast.info("Please select a date time at least 5 minutes from now.");
      }
      setTime(formatTime(e.target.value));
      // this.setState({ time: ts });
      //
      console.log("3nd", e.target.value)
 
    }



  };

  // SECTION Date or Week Handler start
  const dateOrWeekHandler = (e) => {
    // 

    if (e.target.id === "radio3") {
      document.getElementById("radio3").checked = false;
      document.getElementById("radio4").checked = true;
      document.getElementById("1blockdatePicker").disabled = true;
      document.getElementById("1blockdatePicker").value = "";
      document.getElementById("1blockdatePicker").required = false;
    } else if (e.target.id === "radio4") {
      document.getElementById("radio3").checked = false;
      document.getElementById("radio4").checked = true;
      document.getElementById("1blockdatePicker").disabled = false;
      document.getElementById("1blockdatePicker").required = true;
    }
    if (e.target.id === "radio1") {
      document.getElementById("radio2").checked = false;
      document.getElementById("radio1").checked = true;
      document.getElementById("1blockdayOfWeek").disabled = true;
      document.getElementById("1blockweek").disabled = true;
      document.getElementById("1blockmonths").disabled = false;
    } else if (e.target.id === "radio2") {
      document.getElementById("radio1").checked = false;
      document.getElementById("radio2").checked = true;
      document.getElementById("1blockdayOfWeek").disabled = false;
      document.getElementById("1blockweek").disabled = false;
      document.getElementById("1blockmonths").disabled = true;
    }
    if (e.target.id === "radio3week") {
      document.getElementById("radio4week").checked = false;
      document.getElementById("radio3week").checked = true;
      document.getElementById("3BlockDate").disabled = true;
      document.getElementById("3BlockDate").required = false;
    } else if (e.target.id === "radio4week") {
      document.getElementById("radio3week").checked = false;
      document.getElementById("radio4week").checked = true;
      document.getElementById("3BlockDate").disabled = false;
      document.getElementById("3BlockDate").required = true;
    }
    if (e.target.id === "radio3days") {
      document.getElementById("radio4days").checked = false;
      document.getElementById("radio3days").checked = true;
      document.getElementById("2Blockdate").disabled = true;
      document.getElementById("2Blockdate").required = false;
    } else if (e.target.id === "radio4days") {
      document.getElementById("2Blockdate").disabled = false;
      document.getElementById("2Blockdate").required = true;
      document.getElementById("radio3days").checked = false;
      document.getElementById("radio4days").checked = true;
    }
  };
  // !SECTION

  const submitSchedule = (e) => {

    e.preventDefault();
    setLoadingState(true);
    if (campaignScheduleType === "now") {
      let type = campaignScheduleType;
      if (campaignData.campaignName.length > 0) {
        if (campaignData.campaignEditMode) {
          var data = {
            name: campaignData.campaignName,
            description: campaignData.campaignDescription,
            subject: campaignData.campaignSubject,
            data: "",
            templateId: campaignData.campaignTemplateId,
            audienceId: campaignData.campaignAudienceId,
            fromEmail: campaignData.campaignEmail,
            type: campaignData.campaignType,
            isDraft: false,
            cc: campaignData.cc,
            bcc: campaignData.bcc,

            campaignSchedule: {
              type: "now",
              typeValue: null,
              firstRunDate: null,
              runTime: null,
              endDate: null,
              repeatEvery: null,
              daysOfWeek: null,
              dayOfMonth: null,
              weekNumber: null,
              weekDay: null,
              setStyle: "",
            },
          };
          console.log("CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCBBBBBBB",campaignData.cc , campaignData.bcc)

          putCampaignData(data, campaignData.campaignId)
            .then((data) => {
              setLoadingState(false);
              toast.success(
                "Your campaign has been successfully scheduled for sending."
              );
              history.push(`/admin/campaign/all`);
            })
            .catch((err) => {
              toast.error("Something went wrong");
            });
        } else {
          var data = {
            name: campaignData.campaignName,
            description: campaignData.campaignDescription,
            subject: campaignData.campaignSubject,
            data: "",
            templateId: campaignData.campaignTemplateId,
            audienceId: campaignData.campaignAudienceId,
            fromEmail: campaignData.campaignEmail,
            type: campaignData.campaignType,
            isDraft: false,
            cc: campaignData.cc,
            bcc: campaignData.bcc,

            campaignSchedule: {
              type: "now",
              typeValue: null,
              firstRunDate: null,
              runTime: null,
              endDate: null,
              repeatEvery: null,
              daysOfWeek: null,
              dayOfMonth: null,
              weekNumber: null,
              weekDay: null,
              setStyle: "",
            },
          };
          postCampaignData(data, campaignData.campaignId)
            .then((data) => {
              setLoadingState(false);
              toast.success(
                "Your campaign has been successfully scheduled for sending."
              );
              history.push(`/admin/campaign/all`);
            })
            .catch((e) => { });
        }
      } else {
        toast.info("Please enter campaign name");
      }
    } else if (campaignScheduleType === "once") {
      if (campaignData.campaignName.length > 0) {
        var data = {
          name: campaignData.campaignName,
          description: campaignData.campaignDescription,
          subject: campaignData.campaignSubject,
          data: "",
          templateId: campaignData.campaignTemplateId,
          audienceId: campaignData.campaignAudienceId,
          fromEmail: campaignData.campaignEmail,
          type: campaignData.campaignType,
          isDraft: false,
          cc: campaignData.cc,
          bcc: campaignData.bcc,
          campaignSchedule: {
            type: campaignScheduleType,
            typeValue: null,
            firstRunDate: document.getElementById("1blockdate").value,
            runTime: time,
            endDate: null,
            repeatEvery: null,
            daysOfWeek: null,
            dayOfMonth: null,
            weekNumber: null,
            weekDay: null,
          },
        };
        postCampaignData(data, campaignData.campaignId)
          .then((data) => {
            setLoadingState(false);
            toast.success(
              "Your campaign has been successfully scheduled for sending."
            );
            history.push(`/admin/campaign/all`);
          })
          .catch((e) => { });
      } else {
        toast.info("Please enter campaign name");
      }
    } else if (campaignScheduleType === "recurring") {
      // SECTION If Daily
      if (campaignScheduleRecurranceType === "daily") {
        let type = campaignScheduleType;
        let schedule = campaignScheduleRecurranceType;
        let firstRunDate = document.getElementById("2BlockDate").value;
        let firstRunTime = time;
        let repeatEvery = document.getElementById("2BlockrepeatEvery").value;
        let endOnNull = document.getElementById("radio3days").checked
          ? null
          : null;
        let endOnDate = document.getElementById("radio4days").checked
          ? document.getElementById("2Blockdate").value
          : null;
        if (campaignData.campaignName.length > 0) {
          var data = {
            name: campaignData.campaignName,
            description: campaignData.campaignDescription,
            subject: campaignData.campaignSubject,
            data: "",
            type: campaignData.campaignType,
            templateId: campaignData.campaignTemplateId,
            audienceId: campaignData.campaignAudienceId,
            fromEmail: campaignData.campaignEmail,
            isDraft: false,
            cc: campaignData.cc,
            bcc: campaignData.bcc,
            campaignSchedule: {
              type: campaignScheduleType,
              typeValue: campaignScheduleRecurranceType,
              firstRunDate: firstRunDate,
              runTime: firstRunTime,
              endDate: endOnDate,
              repeatEvery: repeatEvery,
              daysOfWeek: null,
              dayOfMonth: null,
              weekNumber: null,
              weekDay: null,
            },
          };

          postCampaignData(data, campaignData.campaignId)
            .then((data) => {
              setLoadingState(false);
              toast.success(
                "Your campaign has been successfully scheduled for sending."
              );
              history.push(`/admin/campaign/all`);
            })
            .catch((e) => { });
        } else {
          toast.info("Please enter campaign name");
        }
      }
      // !SECTION

      // SECTION If Weekly
      else if (campaignScheduleRecurranceType === "weekly") {
        // 
        if (checkArray.length > 0) {
          let type = campaignScheduleType;
          let schedule = campaignScheduleRecurranceType;
          let firstRunDate = document.getElementById("3Blockdate").value;
          let firstRunTime = time;
          let repeatEvery = document.getElementById("3BlockrepeatEvery").value;
          // let checkArray = checkArray;
          let endOnNull = document.getElementById("radio3week").checked
            ? null
            : null;
          let endOnDate = document.getElementById("radio4week").checked
            ? document.getElementById("3BlockDate").value
            : null;

          if (campaignData.campaignName.length > 0) {
            var data = {
              name: campaignData.campaignName,
              description: campaignData.campaignDescription,
              subject: campaignData.campaignSubject,
              data: "",
              templateId: campaignData.campaignTemplateId,
              audienceId: campaignData.campaignAudienceId,
              type: campaignData.campaignType,
              fromEmail: campaignData.campaignEmail,
              isDraft: false,
              cc: campaignData.cc,
              bcc: campaignData.bcc,
              campaignSchedule: {
                type: campaignScheduleType,
                typeValue: campaignScheduleRecurranceType,
                firstRunDate: firstRunDate,
                runTime: firstRunTime,
                endDate: endOnDate,
                repeatEvery: repeatEvery,
                daysOfWeek: checkArray,
                dayOfMonth: null,
                weekNumber: null,
                weekDay: null,
              },
            };

            postCampaignData(data, campaignData.campaignId)
              .then((data) => {
                setLoadingState(false);
                toast.success(
                  "Your campaign has been successfully scheduled for sending."
                );
                history.push(`/admin/campaign/all`);
              })
              .catch((e) => { });
          } else {
            toast.info("Please enter campaign name");
          }
        } else {
          toast.info("Please select atleast one day");
        }
      }
      // !SECTION

      // SECTION If Monthly
      else if (campaignScheduleRecurranceType === "monthly") {
        // 
        let type = campaignScheduleType;
        let schedule = campaignScheduleRecurranceType;
        let firstRunDate = document.getElementById("1blockdate").value;
        let firstRunTime = time;
        let repeatEvery = document.getElementById("1blockrepeatEvery").value;
        let repeatOnDayOfMonth = document.getElementById("radio1").checked
          ? document.getElementById("1blockmonths").value
          : null;
        let repeatOnDayOfWeek = document.getElementById("radio2").checked
          ? document.getElementById("1blockdayOfWeek").value
          : null;
        let repeatOnWeek = document.getElementById("radio2").checked
          ? document.getElementById("1blockweek").value
          : null;
        let endOnNull = document.getElementById("radio3").checked ? null : null;
        let endOnDate = document.getElementById("radio4").checked
          ? document.getElementById("1blockdatePicker").value
          : null;
        if (campaignData.campaignName.length > 0) {
          var data = {
            name: campaignData.campaignName,
            description: campaignData.description,
            subject: campaignData.subject,
            data: "",
            templateId: campaignData.templateId,
            audienceId: campaignData.campaignAudienceId,
            isDraft: false,
            type: campaignData.campaignType,
            fromEmail: campaignData.campaignEmail,
            cc: campaignData.cc,
            bcc: campaignData.bcc,
            campaignSchedule: {
              type: campaignScheduleType,
              typeValue: campaignScheduleRecurranceType,
              firstRunDate: firstRunDate,
              runTime: firstRunTime,
              endDate: endOnDate,
              repeatEvery: repeatEvery,
              daysOfWeek: null,
              dayOfMonth: parseInt(repeatOnDayOfMonth),
              weekNumber: parseInt(repeatOnDayOfWeek),
              weekDay: parseInt(repeatOnWeek),
            },
          };

          postCampaignData(data, campaignData.campaignId)
            .then((res) => {
              setLoadingState(false);
              toast.success(
                "Your campaign has been successfully scheduled for sending."
              );
              history.push(`/admin/campaign/all`);
            })
            .catch((err) => {

            });
        } else {
          toast.info("Please enter campaign name");
        }
      }
      // !SECTION
    }
    dispatch(setCampaignId(""));
    dispatch(setCampaignName(""));
    dispatch(setCampaignDescription(""));
    dispatch(setCampaignSubject(""));
    dispatch(setCampaignType(""));
    dispatch(setCampaignAudienceId(""));
    dispatch(setCampaignAudienceName(""));
    dispatch(setCampignTemplateId(""));
    dispatch(setcampaignEditMode(false));
  };

  const checkArray = [];
  //ANCHOR Check Box Handler for Week Days
  const checkHandler = (e) => {
    const cb = document.getElementById(e.target.id);

    if (cb.checked) {
      checkArray.push(parseInt(cb.value));
    } else {
      var a = checkArray.indexOf(cb.value);
      checkArray.splice(a, 1);
    }
  };
  return (
    <>
      {loadingState ? (
        <ContantLoader />
      ) : (
        <div class="modal fade kwDesignModal kwScheduleModal" id="schedule">
          <div class="modal-dialog kw_md">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">
                  <span class="icon-Group-240"></span>
                </button>
              </div>

              <div class="modal-body">
                <form onSubmit={submitSchedule}>
                  <div className="schedule d-flex flex-wrap align-items-center justify-content-between">
                    <h3 className="font2">Run your campaign now</h3>
                    <input
                      type="submit"
                      className="lg_btn primary"
                      id="Run_Now"
                      value="Run Now"
                      data-dismiss="modal"
                      onClick={(e) => submitSchedule(e)}
                    />
                  </div>

                  <div className="schedule_recurrence">
                    <h4 className="font2">Schedule Recurrence</h4>
                    <p className="font7">
                      Any changes made will replace the current recurrence
                      schedule.
                    </p>

                    <div className="schedule_fields">
                      <div className="row">
                        <div className="kwlabel"> Type :</div>
                        <div className="kwFields">
                          <select
                            required
                            onChange={(e) => scheduleTypeHandler(e)}
                            className="kwDesign1 w143"
                          >
                            <option value="now">Now</option>
                            <option value="once">Once</option>
                            <option value="recurring">Recurring</option>
                          </select>
                        </div>
                      </div>
                      <div
                        style={{ display: "none" }}
                        required
                        onChange={(e) => scheduleRecurranceTypeHandler(e)}
                        className="row"
                        id="schedule-div"
                      >
                        <div className="kwlabel"> Schedule :</div>
                        <div className="kwFields">
                          <select
                            required
                            id="getschedule"
                            className="kwDesign1 w143"
                          >
                            <option id="defaultSelected" disabled>
                              Please Select
                            </option>
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                          </select>
                        </div>
                      </div>
                      <div
                        style={{ display: "none" }}
                        id="1Block"
                        className="schedule-recurrence-block"
                      >
                        <div
                          style={{ display: "none" }}
                          className="row"
                          id="firstRun-div"
                        >
                          <div className="kwlabel"> First Run :</div>
                          <div className="kwFields">
                            <div className="inline-fields-row">
                              <div className="datePickerOuter">
                                <input
                                  id="1blockdate"
                                  onChange={datePickupHandler}
                                  type="date"
                                  min={moment().format("YYYY-MM-DD")}
                                  className="kwDesign md datePicker w143"
                                />
                              </div>
                              &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                              <input
                                id="1blocktime"
                                className="kwDesign md timepicker w143"
                                type="time"
                                onChange={timePickupHandler}
                           
                              />
                              <span className="input_label ml-2">EST</span>
                            </div>
                          </div>
                        </div>

                        <div className="row" id="Repeat-every-div">
                          <div className="kwlabel">Repeat every :</div>
                          <div className="kwFields">
                            <select
                              id="1blockrepeatEvery"
                              className="kwDesign1 w53"
                            >
                              <option value="1">01</option>
                              <option value="2">02</option>
                              <option value="3">03</option>
                              <option value="4">04</option>
                              <option value="5">05</option>
                              <option value="6">06</option>
                              <option value="7">07</option>
                              <option value="8">08</option>
                              <option value="9">09</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                            <p className="font3">Months</p>
                          </div>
                        </div>
                        <div className="row" id="repeat-on-div">
                          <div className="kwlabel">Repeat on :</div>
                          <div className="kwFields">
                            <div className="twoOptions" id="Day-of-month">
                              <div className="kwRadioBtn">
                                <input
                                  onChange={dateOrWeekHandler}
                                  type="radio"
                                  id="radio1"
                                  checked
                                />
                                <label for="radio1" className="kwRadioText">
                                  Day of month
                                </label>
                              </div>
                              <select
                                id="1blockmonths"
                                className="kwDesign1 w53"
                              >
                                <option value="1">01</option>
                                <option value="2">02</option>
                                <option value="3">03</option>
                                <option value="4">04</option>
                                <option value="5">05</option>
                                <option value="6">06</option>
                                <option value="7">07</option>
                                <option value="8">08</option>
                                <option value="9">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                              </select>
                            </div>
                            <div className="twoOptions" id="Day-of-week">
                              <div className="kwRadioBtn">
                                <input
                                  type="radio"
                                  onChange={dateOrWeekHandler}
                                  id="radio2"
                                />
                                <label for="radio2" className="kwRadioText">
                                  Day of week
                                </label>
                              </div>
                              <select
                                id="1blockdayOfWeek"
                                className="kwDesign1 w143 mr-3"
                                disabled
                              >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                              </select>
                              <select
                                id="1blockweek"
                                className="kwDesign1 w143"
                                disabled
                              >
                                <option value="0">Sun</option>
                                <option value="1">Mon</option>
                                <option value="2">Tue</option>
                                <option value="3">Weg</option>
                                <option value="4">THU</option>
                                <option value="5">Fri</option>
                                <option value="6">Sat</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row" id="End-on-div">
                          <div className="kwlabel">End on :</div>
                          <div className="kwFields">
                            <div className="twoOptions" id="No-end-date">
                              <div className="kwRadioBtn">
                                <input
                                  onChange={dateOrWeekHandler}
                                  type="radio"
                                  name="radio3"
                                  id="radio3"
                                  checked
                                />
                                <label for="radio3" className="kwRadioText">
                                  No end date
                                </label>
                              </div>
                            </div>
                            <div className="twoOptions" id="radio4-div">
                              <div
                                className="kwRadioBtn"
                                style={{ minWidth: "20px" }}
                              >
                                <input
                                  type="radio"
                                  onChange={dateOrWeekHandler}
                                  name="radio3"
                                  id="radio4"
                                />
                                <label
                                  for="radio4"
                                  className="kwRadioText"
                                ></label>
                              </div>
                              <div className="datePickerOuter">
                                <input
                                  id="1blockdatePicker"
                                  min={monthManageDate}
                                  type="date"
                                  className="kwDesign md datePicker w143"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* END Block */}
                      {/* 2nd Block starts here*/}
                      <div
                        style={{ display: "none" }}
                        id="2Block"
                        className="schedule-recurrence-block"
                      >
                        <div className="row">
                          <div className="kwlabel"> First Run :</div>
                          <div className="kwFields">
                            <div className="inline-fields-row">
                              <div className="datePickerOuter">
                                <input
                                  onChange={datePickupHandler}
                                  id="2BlockDate"
                                  type="date"
                                  min={moment().format("YYYY-MM-DD")}
                                  className="kwDesign md datePicker w143"
                                />
                              </div>
                              {/* <select className="kwDesign1 w143"> */}
                              &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                              <input
                                id="2BlockTime"
                                className="kwDesign md timepicker w143"
                                type="time"
                                onChange={timePickupHandler}
                              />
                              <span className="input_label ml-2">EST</span>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="kwlabel">Repeat every :</div>
                          <div className="kwFields">
                            <select
                              id="2BlockrepeatEvery"
                              className="kwDesign1 w53"
                            >
                              <option value="1">01</option>
                              <option value="2">02</option>
                              <option value="3">03</option>
                              <option value="4">04</option>
                              <option value="5">05</option>
                              <option value="6">06</option>
                              <option value="7">07</option>
                              <option value="8">08</option>
                              <option value="9">09</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>
                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                              <option value="23">23</option>
                              <option value="24">24</option>
                              <option value="25">25</option>
                              <option value="26">26</option>
                              <option value="27">27</option>
                              <option value="28">28</option>
                              <option value="29">29</option>
                              <option value="30">30</option>
                              <option value="31">31</option>
                            </select>
                            <p className="font3">Days</p>
                          </div>
                        </div>
                        <div className="row" id="End-on-div">
                          <div className="kwlabel">End on :</div>
                          <div className="kwFields">
                            <div className="twoOptions" id="No-end-date">
                              <div className="kwRadioBtn">
                                <input
                                  onChange={dateOrWeekHandler}
                                  checked
                                  type="radio"
                                  name="radio4day"
                                  id="radio3days"
                                />
                                <label for="radio3days" className="kwRadioText">
                                  No end date
                                </label>
                              </div>
                            </div>
                            <div className="twoOptions" id="radio4-div">
                              <div
                                className="kwRadioBtn"
                                style={{ minWidth: "20px" }}
                              >
                                <input
                                  type="radio"
                                  onChange={dateOrWeekHandler}
                                  name="radio4day"
                                  id="radio4days"
                                />
                                <label
                                  for="radio4days"
                                  className="kwRadioText"
                                ></label>
                              </div>
                              <div className="datePickerOuter">
                                <input
                                  id="2Blockdate"
                                  type="date"
                                  min={manageDate}
                                  className="kwDesign md datePicker w143"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* 2nd Block ends here*/}
                      {/* 3rd Block starts here*/}
                      <div
                        style={{ display: "none" }}
                        id="3Block"
                        className="schedule-recurrence-block"
                      >
                        <div className="row">
                          <div className="kwlabel"> First Run :</div>
                          <div className="kwFields">
                            <div className="inline-fields-row">
                              <div className="datePickerOuter">
                                <input
                                  id="3Blockdate"
                                  onChange={datePickupHandler}
                                  type="date"
                                  min={moment().format("YYYY-MM-DD")}
                                  className="kwDesign md datePicker w143"
                                />
                              </div>
                              &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                              <input
                                id="3Blocktime"
                                className="kwDesign md timepicker w143"
                                type="time"
                                onChange={timePickupHandler}
                              />
                              <span className="input_label ml-2">EST</span>
                            </div>
                          </div>
                        </div>

                        <div className="row" id="Repeat-every-div">
                          <div className="kwlabel">Repeat every :</div>
                          <div className="kwFields">
                            <select
                              id="3BlockrepeatEvery"
                              className="kwDesign1 w53"
                            >
                              <option value="1">01</option>
                              <option value="2">02</option>
                              <option value="3">03</option>
                              <option value="4">04</option>

                              {/* <option>08</option> */}
                            </select>
                            <p className="font3">Week</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="kwlabel">Weeks on :</div>
                          <div className="kwFields">
                            <ul className="radio-btn-grp">
                              <li>
                                <div class="inputOuter">
                                  <div class="kwCheckboxBlue">
                                    <input
                                      onChange={checkHandler}
                                      value="0"
                                      type="checkbox"
                                      id="checkbox10"
                                    />
                                    <label
                                      for="checkbox10"
                                      class="kwCheckboxText"
                                    >
                                      Sunday
                                    </label>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="inputOuter">
                                  <div class="kwCheckboxBlue">
                                    <input
                                      onChange={checkHandler}
                                      value="1"
                                      type="checkbox"
                                      id="checkbox11"
                                    />
                                    <label
                                      for="checkbox11"
                                      class="kwCheckboxText"
                                    >
                                      Monday
                                    </label>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="inputOuter">
                                  <div class="kwCheckboxBlue">
                                    <input
                                      onChange={checkHandler}
                                      value="2"
                                      type="checkbox"
                                      id="checkbox13"
                                    />
                                    <label
                                      for="checkbox13"
                                      class="kwCheckboxText"
                                    >
                                      Tuesday
                                    </label>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="inputOuter">
                                  <div class="kwCheckboxBlue">
                                    <input
                                      onChange={checkHandler}
                                      value="3"
                                      type="checkbox"
                                      id="checkbox17"
                                    />
                                    <label
                                      for="checkbox17"
                                      class="kwCheckboxText"
                                    >
                                      Wednesday
                                    </label>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="inputOuter">
                                  <div class="kwCheckboxBlue">
                                    <input
                                      onChange={checkHandler}
                                      value="4"
                                      type="checkbox"
                                      id="checkbox14"
                                    />
                                    <label
                                      for="checkbox14"
                                      class="kwCheckboxText"
                                    >
                                      Thursday
                                    </label>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="inputOuter">
                                  <div class="kwCheckboxBlue">
                                    <input
                                      onChange={checkHandler}
                                      value="5"
                                      type="checkbox"
                                      id="checkbox15"
                                    />
                                    <label
                                      for="checkbox15"
                                      class="kwCheckboxText"
                                    >
                                      Friday
                                    </label>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="inputOuter">
                                  <div class="kwCheckboxBlue">
                                    <input
                                      onChange={checkHandler}
                                      value="5"
                                      type="checkbox"
                                      id="checkbox16"
                                    />
                                    <label
                                      for="checkbox16"
                                      class="kwCheckboxText"
                                    >
                                      Saturday
                                    </label>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="row" id="End-on-div">
                          <div className="kwlabel">End on :</div>
                          <div className="kwFields">
                            <div className="twoOptions" id="No-end-date">
                              <div className="kwRadioBtn">
                                <input
                                  checked
                                  onChange={dateOrWeekHandler}
                                  type="radio"
                                  name="radio4"
                                  id="radio3week"
                                />
                                <label for="radio3week" className="kwRadioText">
                                  No end date
                                </label>
                              </div>
                            </div>
                            <div className="twoOptions" id="radio4-div">
                              <div
                                className="kwRadioBtn"
                                style={{ minWidth: "20px" }}
                              >
                                <input
                                  type="radio"
                                  onChange={dateOrWeekHandler}
                                  name="radio4"
                                  id="radio4week"
                                />
                                <label
                                  for="radio4week"
                                  className="kwRadioText"
                                ></label>
                              </div>
                              <div className="datePickerOuter">
                                <input
                                  id="3BlockDate"
                                  min={weekManageDate}
                                  type="date"
                                  className="kwDesign md datePicker w143"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* 3rd Block ends here*/}
                    </div>
                    <div class="footerBtn d-flex justify-content-center align-items-center">
                      <input
                        type="submit"
                        className="lg_btn primary"
                        value="Finalize"
                        id="finalize"
                        data-dismiss="modal"
                        onClick={(e) => submitSchedule(e)}
                      />
                      <a to="" class="lg_btn tertiary" data-dismiss="modal">
                        Cancel
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
